import { useQuery } from '@tanstack/react-query';
import { useApiClient } from '../../../apiClient';
import { UserCohortDto } from '../../../models/user-cohort/dto/user-cohort.dto';

export const GET_COHORT_QUERY_KEY = (cohortId: string) => ['cohort', cohortId];

export function useGetCohort(cohortId?: string) {
  const apiClient = useApiClient();

  return useQuery<UserCohortDto>({
    enabled: Boolean(cohortId),
    queryKey: GET_COHORT_QUERY_KEY(cohortId!),
    queryFn: async (): Promise<UserCohortDto> => {
      const response = await apiClient.fetchApi<UserCohortDto, {}>({
        method: 'GET',
        endpoint: `cohorts/${cohortId}`,
      });
      return response;
    },
  });
}
